import { useSelector } from 'react-redux';

export const menuItemsDynamic = () => {
  const categoryMenu = useSelector(({ CategoriesChips }) => CategoriesChips);

  const categoryItems = [];

  if (categoryMenu && !categoryMenu.isLoading && categoryMenu.items) {
    const fetchedCategoryItems =
      categoryMenu.items.length > 5
        ? categoryMenu.items.slice(0, 5)
        : categoryMenu.items;

    categoryItems.push(...fetchedCategoryItems); // spread the fetched items
    categoryItems.push({
      name: `Mostrar todas`,
      path: '/categories',
    });
  }
  return categoryItems;
};
